<template>
  <div class="backdrop">
    <div class="detail-wrapper common">
      <div class="detail-goods">
        <img :src="goodsInfo.image_url" v-if="goodsInfo.image_url">
        <img v-else src="../../../assets/images/no-picture.jpg">
        <div class="describe">
          <div class="title">{{goodsInfo.goods_name}}</div>
          <div>{{goodsInfo.goods_num}}</div>
          <div>金额：{{goodsInfo.total_goods_price}}<span>库存：{{goodsInfo.total_goods_count}}（当前小区）</span></div>
        </div>
      </div>
      <!-- <div class="detail-type">
        <div class="block"><img src="../../../assets/images/navigation-index.png"><div>资产详情</div></div>
      </div> -->
    </div>
    <div class="tag-wrapper common">
      <div class="row">
        <div>物资类型</div>
        <div v-if="goodsInfo.goods_type === 1">易耗品</div>
        <div v-else>资产</div>
      </div>
      <div class="row">
        <div>分类</div>
        <div><span v-if="goodsInfo.category_pname">{{goodsInfo.category_pname}}-</span>{{goodsInfo.category_name}}</div>
      </div>
      <div class="row">
        <div>单价</div>
        <div>{{goodsInfo.price}}</div>
      </div>
      <div class="row">
        <div>默认供应商</div>
        <div>{{goodsInfo.supplier_name}}</div>
      </div>
      <div class="row">
        <div>规格型号</div>
        <div>{{goodsInfo.specification}}</div>
      </div><div class="row">
        <div>品牌商标</div>
        <div>{{goodsInfo.brand}}</div>
      </div>
      <div class="row">
        <div>安全库存上限</div>
        <div>{{goodsInfo.safe_stock_lower_limit}}</div>
      </div>
      <div class="row">
        <div>安全库存下限</div>
        <div>{{goodsInfo.safe_stock_upper_limit}}</div>
      </div>
      <div class="row">
        <div>使用期限（月）</div>
        <div>{{goodsInfo.service_life}}</div>
      </div>
      <div class="row" v-for="(item, index) in goodsInfo.attribute_msg" :key="index">
        <div>{{item.goods_attribute_name}}</div>
        <div v-if="item.type== 3">{{item.option_text}}</div>
        <div v-else>{{item.value}}</div>
      </div>
      <div class="row">
        <div>备注</div>
        <div>{{goodsInfo.goods_remark}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'GoodsDetail',
  metaInfo: {
    title: '物品档案'
  },
  data () {
    return {
      goodsInfo: [],
      goods_id: 0
    }
  },
  computed: {
    ...mapState(['villageId', 'userId'])
  },
  created () {
    this.goods_id = this.$route.query.goods_id
    this.getGoodsDetail()
  },
  methods: {
    getGoodsDetail () {
      this.axios.post('/wechat/Goods/GoodsDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        goods_id: this.goods_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.goodsInfo = res.data.data
          console.log(res.data.data)
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.detail-wrapper .detail-goods {
  display: flex;
  color: #989898;
  font-size: 13px;
}
.detail-wrapper .detail-goods img {
  width: 75px;
  height: 75px;
}
.detail-wrapper .detail-goods .describe {
  flex: 1;
  padding-left: 12px;
}
.detail-wrapper .detail-goods .describe .title {
  font-size: 15px;
  color: #43464f;
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.detail-wrapper .detail-goods .describe span {
  margin-left: 15px;
}
.detail-wrapper .detail-type {
  border-top: 1px solid #f6f6f6;
  margin-top: 15px;
  overflow: hidden;
  font-size: 14px;
  padding-top: 15px;
  color: #43464f;
}
.detail-wrapper .detail-type .block {
  width: 25%;
  float: left;
  text-align: center;
}
.detail-wrapper .detail-type .block img {
  width: 25px;
  height: 25px;
}
.tag-wrapper .row {
  display: flex;
  font-size: 14px;
  border-bottom: 1px solid #f6f6f6;
  padding: 8px 0;
}
.tag-wrapper .row div:last-child {
  flex: 1;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Goods/GoodsDetail.vue